import React, { useState, useRef} from 'react';
import './home/home.css';
import '../App.css'
import './rightbtn.css'
import { connect } from 'react-redux';
import { useLang } from '../hook/UseLang';
import CONTENT from '../contents/nav.js';
const RightSizePops = ({control}) => {
    const [activeTab, setActiveTab] = useState(null);
    const [lang, setLang] = useLang()
    const langRef = useRef()
    const resRef = useRef()
    
    const handleTabClick = (tab) => {
        setActiveTab(activeTab === tab ? null : tab);
    };
    const handleClick = () =>{
        if(langRef.current.classList.contains('is-lang-opened')){
            langRef.current.classList.remove('is-lang-opened');
        } else {
            langRef.current.classList.add('is-lang-opened');
        }
    }
    return (
        <div ref={langRef} className="overflow-hidden is-lang-closed flex flex-col items-start justify-start absolute top-[60%] d-show-m-hidden" style={{opacity:control?.hideMenu?0:1, transition:'all .5s ease', zIndex:9999999}}>
            <div className='relative overall_size bg-[#9B998F] flex flex-row items-center'>
                <div onClick={() => handleClick()} className='text-white text-d-16 vert-text open_btn h-full flex flex-row items-center justify-center cursor-pointer select-none playfair-display'>{CONTENT.lang[lang]}</div>
                <div className='flex flex-col items-center justify-center text-d-12 font-[500] text-white border-l border-l-white h-full' style={{flex:1, gap:12}}>
                    <div className='cursor-pointer select-none playfair-display hover:font-bold text-d-14' onClick={() => {setLang('en');handleClick()}} style={{fontWeight:lang === 'en' ? 800 : ''}}>English</div>
                    <div className='cursor-pointer select-none playfair-display hover:font-bold text-d-14' onClick={() => {setLang('sc');handleClick()}} style={{fontWeight:lang === 'sc' ? 800 : ''}}>中文简体</div>
                    <div className='cursor-pointer select-none playfair-display hover:font-bold text-d-14' onClick={() => {setLang('tc');handleClick()}} style={{fontWeight:lang === 'tc' ? 800 : ''}}>中文繁體</div>
                </div>
            </div>
        </div>
    );
};

export default connect((store)=>{
    return{
      control:store.controlReducer,
    }
  })(RightSizePops)